import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel - fires once on mount
    ;
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '1478220336975840');
    window.fbq('track', 'PageView');
  }, []);
  return <SalesPage data-id="element-0" />;
}